// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__YKcYb","name":"name__jHvSy","badge":"badge__-4NVf"};